const axios = require('axios');

/* ===== Get user's studios ===== */
const getUserStudios = async (email, token, moduleType, zohoId) => {
    // console.log("test");
    const body = {
        email: email,
        moduleType: moduleType,
        token: token,
        zohoId: zohoId,
    }
    
    const res = await axios.post('/api/user/getStudios', body);
    // console.log(res.data);
    if (res && res.data) {
        return res.data;
    }
    return {
        status: false,
    };
}

// ================================

/* ===== Get user's progress data ===== */

const fetchProgressData = async function(dataObj) {
    try {
      let url;
      if (dataObj.api_key) {
        url = `/api/user/myProgress?id=${dataObj.id}&api_key=${dataObj.api_key}`;
      }
      else {
        url = `/api/user/myProgress?email=${dataObj.email}&token=${dataObj.token}`;
      }
      const progressDataResponse = await axios(url);
      // console.log(progressDataResponse.data);
      return progressDataResponse.data;
    }
    catch(err) {
      console.log("Error getting user progress data...");
      console.log(err);
      return {
        status: false,
        message: 'something_went_wrong_try_again'
      };
    }
  }

module.exports = {
    getUserStudios,
    fetchProgressData
}